/**
 * Main bundle entry.
 * Add all main theme imports here.
 *
 * - jqueryLoad — Use jQuery as $ globally within bundle.
 * - prototypes — Small additions to jQuery and polyfills.
 */
import './config/jqueryLoad';
import './lib/prototypes';

// Main theme scripts.
import './lib/accessibility';
import './lib/alert-bar';
import './lib/animation-helpers';
import './lib/animations';
import './lib/cookie-notice';
// import './lib/crms';
import './lib/header';
import './lib/lazy';
import './lib/class-mobile-menu';
import './lib/scroll-direction';
import './lib/modules';
import './lib/print';
import './lib/resize';
import './lib/search';
import './lib/social';
import './lib/sticky';
import './lib/video';
